import { Mail, Image as ImageIcon, Sparkles } from "lucide-react";
import { useSilver } from "@/context/SilverContext";
import { FORMATS } from "@/data/content";
import { cn } from "@/lib/utils";

const FORMAT_ICONS = { letter: Mail, postcard: ImageIcon, unsure: Sparkles };

// Compact format selector that sits under the audience number.
export function FormatChips() {
  const { campaign, updateCampaign } = useSilver();
  return (
    <div>
      <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between sm:gap-3">
        <h4 className="text-[15px] font-bold tracking-[-0.02em]">Choose a format</h4>
        <p className="text-[11px] text-white/40">Spec and pricing confirmed by the Print team</p>
      </div>
      <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-3" role="radiogroup" aria-label="Campaign format">
        {FORMATS.map((f) => {
          const Icon = FORMAT_ICONS[f.id];
          const on = campaign.format === f.id;
          return (
            <button key={f.id} type="button" role="radio" aria-checked={on} onClick={() => updateCampaign({ format: f.id })} title={f.body}
              className={cn("glass glass-hover flex items-center gap-2.5 !rounded-xl px-3 py-2.5 text-left", on && "glass-active")} data-testid={`format-card-${f.id}`}>
              <Icon className={cn("h-4 w-4 shrink-0", on ? "text-[#C6EE5A]" : "text-white/50")} />
              <span className={cn("text-[13px] font-semibold", on ? "text-white" : "text-white/75")}>{f.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
